export const currentPricingRows = [
  ['Visit calls', '$1 per 1k'],
  ['Extract calls', '$2 per 1k'],
  ['Proxy/AI cost', 'Cost plus'],
  ['Max concurrency', '200'],
];

export const paygPricingRows = [
  ['Visit calls', '$2 per 1k'],
  ['Extract calls', '$4 per 1k'],
  ['Proxy/AI cost', 'Cost plus'],
  ['Max concurrency', '50'],
];

export const enterprisePricingRows = [
  ['Visit calls', 'Custom'],
  ['Extract calls', 'Custom'],
  ['Proxy/AI cost', 'Custom'],
  ['Max concurrency', 'Custom'],
];

export const billingPlans = [
  {
    id: 'payg',
    title: 'Pay as you go',
    price: '$0/mo',
    subtitle: 'Buy credits only when you need them. Usage runs at 2x current prices.',
    badge: 'Flexible',
    buttonLabel: 'Buy credits',
    checkoutTitle: 'Buy pay-as-you-go credits',
    checkoutDescription: 'Start with $5 of credits. Usage is priced at the pay-as-you-go rates shown on this page.',
    rows: paygPricingRows,
  },
  {
    id: 'monthly_10',
    title: 'Monthly subscription',
    price: '$10/mo',
    subtitle: 'Current usage prices with a 50% discount from pay-as-you-go rates.',
    badge: '50% discount',
    buttonLabel: 'Start monthly',
    checkoutTitle: 'Start monthly subscription',
    checkoutDescription: 'Pay $10 each month, discounted 50% compared to pay-as-you-go rates..',
    rows: currentPricingRows,
  },
  {
    id: 'enterprise',
    title: 'Custom/enterprise',
    price: 'Custom',
    subtitle: 'Rates and limits based on your traffic, workflows, and support needs.',
    badge: 'Tailored',
    buttonLabel: 'Contact us',
    rows: enterprisePricingRows,
    href: 'mailto:help@fetchfoxai.com?subject=FetchFox%20enterprise%20billing',
  },
];
